// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1198": "1d5f9070","3414": "1f83f97e","8966": "e505230b","9834": "8fb6355b",}[chunkId] + ".css"
}